// extracted by css-extract-rspack-plugin
export default {"container":"SecondarySuggestions-module__container__YYnoN"};